<div class="p-3 w-100">
  <div class="d-flex justify-content-start align-items-center">
    <img
      fetchpriority="high"
      width="136"
      height="90"
      src="images/ai-kosh-logo.svg"
      alt="AIKosh"
      title="AIKosh"
      class="ms-auto me-auto"
    />
  </div>
</div>

<div class="p-4 main-container">
  <div class="form-container">
    <div class="mb-4">
      <h1 class="text-2xl fw-600 mb-2">Let's confirm your details</h1>
      <p class="detail-desc mb-0">
        We noticed a difference between your existing AIKosh account and your
        new Jan Parichay login. Choose the details you want to keep.
      </p>
    </div>

    <!-- Email Confirmed Section -->
    <div class="email-confirmed-section p-4 mb-4">
      <div class="d-flex align-items-center gap-3">
        <div class="status-badge success">
          <img src="images/success.svg" height="100%" width="100%" alt="" />
        </div>
        <div class="flex-grow-1">
          <h3 class="text-base fw-600 mb-2 text-green">Email Confirmed</h3>
          <p class="detail-desc mb-0">
            Your email <strong>{{ userDetails?.email }}</strong> matches on both
            platforms. Only the phone number differs.
          </p>
        </div>
      </div>
    </div>

    <!-- Phone Selection Section -->
    <form [formGroup]="phoneSelectionForm">
      <div class="card-container p-4">
        <h3 class="text-base fw-600 mb-4">
          Select phone number to continue with
        </h3>

        <div class="phone-options mb-4">
          @for (phoneOption of multiplePhones; track phoneOption.phone) {
            <div
              class="phone-option"
              [class.selected]="selectedPhone?.phone === phoneOption.phone"
              (click)="onPhoneSelection(phoneOption)"
            >
              <app-radio-input
                name="phoneSelection"
                [inputId]="phoneOption.phone"
                [value]="phoneOption.phone"
                [control]="selectedPhoneControl"
                (change)="onPhoneSelection(phoneOption)"
              >
                <div class="fw-600">{{ phoneOption.phone }}</div>
                <div class="text-sm text__gray">
                  from your {{ phoneOption.provider }} Account
                </div>
              </app-radio-input>
            </div>
          }
        </div>
      </div>
    </form>

    <!-- Confirmation Checkbox -->
    <div class="pt-3 my-4">
      <app-checkbox-input
        inputId="confirmSelection"
        [control]="isConfirmedControl"
      >
        I understand that the removed details cannot be recovered, and I want to
        proceed with my selection above.
      </app-checkbox-input>
    </div>

    <!-- Action Buttons -->
    <button
      class="form-button btn-confirm"
      type="button"
      (click)="onConfirmSelection()"
      [disabled]="!phoneSelectionForm.valid"
    >
      Confirm & Complete Migration
    </button>

    @if (userDetails?.isLoggedInUser) {
      <button
        class="form-button btn-skip mt-3"
        type="button"
        (click)="onSkipSelection()"
      >
        Skip for Now
      </button>
    }

    <!-- FAQ Link -->
    <div class="text-center mt-4">
      <p class="text-sm">
        Having trouble?
        <a
          [routerLink]="['/', routes.home, routes.faqs]"
          class="text__green view-faq"
          >View FAQ</a
        >
      </p>
    </div>
  </div>
</div>
